module.exports = __webpack_public_path__ + "static/christy-73289ac18525d9f35249d5278a2335a3.jpg";